import React from 'react'
import KeywordUI from "./thumb_label.presenter";

export default function ThumbLabelContainer({thumb_label}){

    return(<KeywordUI thumb_label={thumb_label}/>)
}



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/thumb_label/thumb_label.container.js